import { BlockTitle } from "@blocks/Blocks";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { NOMINATIONS_TAB } from "@dta/components/DTAConstants";
import { HowToNominateTabsFactory } from "@dta/components/HowToNominate/utils/helper";
import NominationsTabDesktop from "@events-awards/EventAwardsNominationsComponents/NominationsTabDesktop";
import NominationsTabMobile from "@events-awards/EventAwardsNominationsComponents/NominationsTabMobile";
import useDropdown from "@hooks/useDropdown";
import useTabs from "@hooks/useTabs";
import { cn } from "@util/helpers";

/**
 * Component to render DTA How to Nominate page
 */
const DTAHowToNominatePage = (): React.ReactElement => {
  const { isOpen, toggleDropdown, closeDropdown } = useDropdown();
  const { activeTab, activeLabel, changeTab } = useTabs(NOMINATIONS_TAB);

  const label = NOMINATIONS_TAB.find((t) => t.key === activeTab)?.label;

  const HowToNominateTabs = HowToNominateTabsFactory(activeTab);

  return (
    <div data-testid="dta-how-to-nominate-page-component">
      <div className="relative mb-5 w-full font-public-sans lg:hidden">
        <ButtonFactory
          buttonType={ButtonType.Secondary}
          text={activeLabel}
          icon={
            <IconFactory
              type={IconTypeEnum.arrowDown}
              x={20}
              y={22}
              size={20}
            />
          }
          iconPosition="right"
          onClick={toggleDropdown}
          className={cn(
            "flex w-full items-center justify-between rounded-full border border-black bg-white px-4 py-2 font-public-sans text-base font-semibold text-blue-175 hover:!underline",
            { "text-gray-875 !underline": isOpen }
          )}
        />

        {isOpen ? (
          <NominationsTabMobile
            activeLabel={activeLabel}
            changeTab={changeTab}
            closeDropdown={closeDropdown}
            className="mx-2 my-1 rounded-lg text-gray-875"
            nominationsTabList={NOMINATIONS_TAB}
          />
        ) : null}
      </div>

      <NominationsTabDesktop
        activeTab={activeTab}
        changeTab={changeTab}
        nominationsTabList={NOMINATIONS_TAB}
      />

      <BlockTitle
        text={label || ""}
        rootClassName="text-4xl lg:text-6xl font-medium mb-5"
      />

      {HowToNominateTabs ? <HowToNominateTabs /> : null}
    </div>
  );
};

export default DTAHowToNominatePage;
